module.exports = __webpack_public_path__ + "static/media/bmw-new-generation-engines.d3dac05a.jpg";